import React from 'react';
import { styled } from '@mui/material/styles';
import { Button, ButtonProps } from '@mui/material';

const StyledButton = styled(Button, {
    shouldForwardProp: prop => prop !== 'isSecondary'
})<{ isSecondary: boolean }>(({ theme, isSecondary }) => ({
    textTransform: 'none',
    marginTop: theme.spacing(1),
    padding: theme.spacing(1.5, 2),
    fontWeight: 700,
    height: '50px',
    ...(isSecondary && {
        borderWidth: '2px',
        borderColor: theme.palette.primary.main,
        backgroundColor: theme.palette.background.default,
        '&:hover': {
            borderWidth: '2px',
            borderColor: theme.palette.primary.main,
            backgroundColor: theme.palette.background.default
        }
    })
}));

interface ButtonV2 extends ButtonProps {
    secondary?: boolean;
}

// TODO: think about better naming
export const ButtonV2: React.FC<React.PropsWithChildren<ButtonV2>> = ({ secondary, ...props }) => (
    <StyledButton
        fullWidth
        variant={secondary ? 'outlined' : 'contained'}
        isSecondary={!!secondary}
        color="primary"
        {...props}
        className={props.className}
    />
);
